const panelFieldGroupTheme = {
  slots: {
    root: 'min-w-0',
    label: 'mb-1 flex min-w-0 items-center gap-1 truncate text-[11px] leading-none text-muted',
    container: 'flex min-w-0 flex-col gap-1.5 justify-between'
  }
}

export type PanelFieldGroupTheme = typeof panelFieldGroupTheme
export default panelFieldGroupTheme
